import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { UrineAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-urine-slot',
    templateUrl: './urine-slot.component.html',
    styleUrl: './urine-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UrineSlotComponent implements SheetSlotComponentBase {

	action!: UrineAction;
	value!: string | null;

	@Input('action') set updateAction(action: UrineAction | null) {
		this.action = action as UrineAction;
		this.value = this.action.urinePassed ? 'Yes' : 'No';
	}

	constructor() {
	}
}